module.exports = __webpack_public_path__ + "img/centered-logo-nav-mazda.2a3a279d.png";